import { Pipe, PipeTransform } from '@angular/core';
import { Block } from '../interfaces';

@Pipe({
    name: 'markDoneBlocks'
})
export class MarkDoneBlocksPipe implements PipeTransform {
    transform(blocks: Block[], currentContainerBlockId: string): Block[] {
        const activeIndex = blocks.findIndex(block => block.id === currentContainerBlockId);
        return blocks.map((block, index) => ({
            ...block,
            done: index < activeIndex
        }));
    }
}
